const INPUT_STYLES = {
  'font-size': '14px',
  'border-radius': '6px',
  height: '40px',
}

const LABEL_STYLES = {
  'font-size': '14px',
  'font-weight': '600',
}

const ERROR_STYLES = {
  'font-size': '12px',
}

export const CARD_FORM_STYLES = {
  card_number: {
    input: INPUT_STYLES,
    '.input-block': {
      input: { 'padding-left': '14px !important' },
    },
    '.label': LABEL_STYLES,
    '.error-text': ERROR_STYLES,
    i: {
      display: 'none !important',
    },
  },
  expiry_date: {
    input: INPUT_STYLES,
    '.label': LABEL_STYLES,
    '.error-text': ERROR_STYLES,
  },
  card_cvv: {
    input: INPUT_STYLES,
    '.label': LABEL_STYLES,
    '.error-text': ERROR_STYLES,
    '.tooltip-icon': {
      display: 'none !important',
    },
  },
  card_holder: {
    input: INPUT_STYLES,
    '.label': LABEL_STYLES,
    '.error-text': ERROR_STYLES,
  },
  two_columns: {
    gap: '16px',
  },
  submit_button: {
    display: 'none',
  },
}

export const CARD_FORM_PARAMS = {
  isCardHolderVisible: true,
  autoFocus: false,
  allowSubmit: false,
  cardNumberLabel: 'Card Number',
  cardNumberPlaceholder: '1234 1234 1234 1234',
  cardExpiryDateLabel: 'Expiration Date',
  cardExpiryDatePlaceholder: 'MM/YY',
  cardCvvLabel: 'CVV',
  cardCvvPlaceholder: '***',
  cardHolderLabel: 'Card holder name',
  cardHolderPlaceholder: 'Full name',
}

export const GOOGLE_PAY_BUTTON_PARAMS = {
  enabled: true,
  type: 'plain',
  color: 'black',
}

export const APPLE_PAY_BUTTON_PARAMS = {
  enabled: true,
  type: 'plain',
  color: 'black',
  integrationType: 'js',
}

export const PAYPAL_BUTTON_PARAMS = {
  enabled: true,
  label: 'paypal',
  color: 'white',
  shape: 'pill',
  height: 44,
}
